export default __webpack_public_path__ + "static/download-mp3-0212c2fc701f0e630d5c32f92f0efa29.svg";